import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyByR7-8a_FXpGlQb5L1DxpuSK0WLioB8Gk",
  authDomain: "padelorcereserva2025-d3766.firebaseapp.com",
  projectId: "padelorcereserva2025-d3766",
  storageBucket: "padelorcereserva2025-d3766.firebasestorage.app",
  messagingSenderId: "1002347033580",
  appId: "1:1002347033580:web:6f9dbf561cfaa5999f06c9"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);